const OWNER_NAVIGATION = [
  ["home", "⌂", "Home"],
  ["daily-rhythm", "◌", "Daily Rhythm"],
  ["relationships", "♧", "Relationships"],
  ["transactions", "▤", "Transactions"],
  ["calendar", "□", "Calendar"],
  ["marketing", "◈", "Marketing"],
  ["journeys", "↗", "Journeys"],
  ["academy", "△", "Academy"],
  ["library", "▥", "Library"],
  ["reports", "▦", "Reports"],
  ["settings", "⚙", "Settings"]
];

const NAVIGATION = {
  SYSTEM_OWNER: OWNER_NAVIGATION,
  OWNER: OWNER_NAVIGATION,
  PARTNER: OWNER_NAVIGATION,
  DIRECTOR_OF_OPERATIONS: [
    ["home", "⌂", "Home"],
    ["daily-rhythm", "◌", "Daily Rhythm"],
    ["transactions", "▤", "Transactions"],
    ["operations", "◫", "Operations"],
    ["team", "♧", "Team"],
    ["marketing", "◈", "Marketing"],
    ["calendar", "□", "Calendar"],
    ["journeys", "↗", "Journeys"],
    ["academy", "△", "Academy"],
    ["library", "▥", "Library"],
    ["reports", "▦", "Reports"]
  ],
  TRANSACTION_COORDINATOR: [
    ["home", "⌂", "Home"],
    ["transactions", "▤", "Transactions"],
    ["calendar", "□", "Calendar"],
    ["tasks", "✓", "Tasks"],
    ["library", "▥", "Library"]
  ],
  ADMIN: [
    ["home", "⌂", "Home"],
    ["transactions", "▤", "Transactions"],
    ["calendar", "□", "Calendar"],
    ["tasks", "✓", "Tasks"],
    ["library", "▥", "Library"]
  ],
  AGENT: [
    ["home", "⌂", "Home"],
    ["daily-rhythm", "◌", "Daily Rhythm"],
    ["relationships", "♧", "My Relationships"],
    ["transactions", "▤", "My Transactions"],
    ["calendar", "□", "Calendar"],
    ["tasks", "✓", "Tasks"],
    ["academy", "△", "Academy"],
    ["library", "▥", "Library"]
  ]
};

function normalizeRole(role) {
  const normalized = String(role || "")
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, "_");

  if (normalized === "SYSTEMOWNER") return "SYSTEM_OWNER";
  return normalized;
}

export function navigationFor(role) {
  return NAVIGATION[normalizeRole(role)] || NAVIGATION.AGENT;
}
